import { Listeners } from './utils.js';

// Awesomplete - Lea Verou - MIT license
!function(){function c(a){var b=Array.isArray(a)?{label:a[0],value:a[1]}:"object"==typeof a&&"label"in a&&"value"in a?a:{label:a,value:a};this.label=b.label||b.value,this.value=b.value}function b(a,b){return"string"==typeof a?(b||document).querySelector(a):a||null}function e(a,b){return g.call((b||document).querySelectorAll(a))}function d(){e("input.awesomplete").forEach(function(b){new a(b)})}var a=function(d,c){var e=this;a.count=(a.count||0)+1,this.count=a.count,this.isOpened=!1,this.input=b(d),this.input.setAttribute("autocomplete","off"),this.input.setAttribute("aria-expanded","false"),this.input.setAttribute("aria-owns","awesomplete_list_"+this.count),this.input.setAttribute("role","combobox"),this.options=c=c||{},function(b,e,f){for(var a in e){var c=e[a],d=b.input.getAttribute("data-"+a.toLowerCase());"number"==typeof c?b[a]=parseInt(d):!1===c?b[a]=null!==d:c instanceof Function?b[a]=null:b[a]=d,b[a]||0===b[a]||(b[a]=a in f?f[a]:c)}}(this,{minChars:2,maxItems:10,autoFirst:!1,data:a.DATA,filter:a.FILTER_CONTAINS,sort:!1!==c.sort&&a.SORT_BYLENGTH,container:a.CONTAINER,item:a.ITEM,replace:a.REPLACE,tabSelect:!1},c),this.index=-1,this.container=this.container(d),this.ul=b.create("ul",{hidden:"hidden",role:"listbox",id:"awesomplete_list_"+this.count,inside:this.container}),this.status=b.create("span",{className:"visually-hidden",role:"status","aria-live":"assertive","aria-atomic":!0,inside:this.container,textContent:0!=this.minChars?"Type "+this.minChars+" or more characters for results.":"Begin typing for results."}),this._events={input:{input:this.evaluate.bind(this),blur:this.close.bind(this,{reason:"blur"}),keydown:function(b){var a=b.keyCode;e.opened&&(13===a&&e.selected?(b.preventDefault(),e.select()):9===a&&e.selected&&e.tabSelect?e.select():27===a?e.close({reason:"esc"}):38!==a&&40!==a||(b.preventDefault(),e[38===a?"previous":"next"]()))}},form:{submit:this.close.bind(this,{reason:"submit"})},ul:{mousedown:function(a){a.preventDefault()},click:function(b){var a=b.target;if(a!==this){for(;a&&!/li/i.test(a.nodeName);)a=a.parentNode;a&&0===b.button&&(b.preventDefault(),e.select(a,b.target))}}}},b.bind(this.input,this._events.input),b.bind(this.input.form,this._events.form),b.bind(this.ul,this._events.ul),this.input.hasAttribute("list")?(this.list="#"+this.input.getAttribute("list"),this.input.removeAttribute("list")):this.list=this.input.getAttribute("data-list")||c.list||[],a.all.push(this)};a.prototype={set list(t){if(Array.isArray(t))this._list=t;else if("string"==typeof t&&t.indexOf(",")> -1)this._list=t.split(/\s*,\s*/);else if((t=b(t))&&t.children){var f=[];g.apply(t.children).forEach(function(a){if(!a.disabled){var b=a.textContent.trim(),c=a.value||b,d=a.label||b;""!==c&&f.push({label:d,value:c})}}),this._list=f}document.activeElement===this.input&&this.evaluate()},get selected(){return this.index> -1},get opened(){return this.isOpened},close:function(a){this.opened&&(this.input.setAttribute("aria-expanded","false"),this.ul.setAttribute("hidden",""),this.isOpened=!1,this.index=-1,this.status.setAttribute("hidden",""),b.fire(this.input,"awesomplete-close",a||{}))},open:function(){this.input.setAttribute("aria-expanded","true"),this.ul.removeAttribute("hidden"),this.isOpened=!0,this.status.removeAttribute("hidden"),this.autoFirst&& -1===this.index&&this.goto(0),b.fire(this.input,"awesomplete-open")},destroy:function(){if(b.unbind(this.input,this._events.input),b.unbind(this.input.form,this._events.form),!this.options.container){var c=this.container.parentNode;c.insertBefore(this.input,this.container),c.removeChild(this.container)}this.input.removeAttribute("autocomplete"),this.input.removeAttribute("aria-autocomplete");var d=a.all.indexOf(this);-1!==d&&a.all.splice(d,1)},next:function(){var a=this.ul.children.length;this.goto(this.index<a-1?this.index+1:a?0:-1)},previous:function(){var b=this.ul.children.length,a=this.index-1;this.goto(this.selected&& -1!==a?a:b-1)},goto:function(a){var c=this.ul.children;this.selected&&c[this.index].setAttribute("aria-selected","false"),this.index=a,a> -1&&c.length>0&&(c[a].setAttribute("aria-selected","true"),this.status.textContent=c[a].textContent+", list item "+(a+1)+" of "+c.length,this.input.setAttribute("aria-activedescendant",this.ul.id+"_item_"+this.index),this.ul.scrollTop=c[a].offsetTop-this.ul.clientHeight+c[a].clientHeight,b.fire(this.input,"awesomplete-highlight",{text:this.suggestions[this.index]}))},select:function(a,d){if(a?this.index=b.siblingIndex(a):a=this.ul.children[this.index],a){var c=this.suggestions[this.index];b.fire(this.input,"awesomplete-select",{text:c,origin:d||a})&&(this.replace(c),this.close({reason:"select"}),b.fire(this.input,"awesomplete-selectcomplete",{text:c}))}},evaluate:function(){var b=this,a=this.input.value;a.length>=this.minChars&&this._list&&this._list.length>0?(this.index=-1,this.ul.innerHTML="",this.suggestions=this._list.map(function(d){return new c(b.data(d,a))}).filter(function(c){return b.filter(c,a)}),!1!==this.sort&&(this.suggestions=this.suggestions.sort(this.sort)),this.suggestions=this.suggestions.slice(0,this.maxItems),this.suggestions.forEach(function(c,d){b.ul.appendChild(b.item(c,a,d))}),0===this.ul.children.length?(this.status.textContent="No results found",this.close({reason:"nomatches"})):(this.open(),this.status.textContent=this.ul.children.length+" results found")):(this.close({reason:"nomatches"}),this.status.textContent="No results found")}},a.all=[],a.FILTER_CONTAINS=function(a,c){return RegExp(b.regExpEscape(c.trim()),"i").test(a)},a.FILTER_STARTSWITH=function(a,c){return RegExp("^"+b.regExpEscape(c.trim()),"i").test(a)},a.SORT_BYLENGTH=function(a,b){return a.length!==b.length?a.length-b.length:a<b?-1:1},a.CONTAINER=function(a){return b.create("div",{className:"awesomplete",around:a})},a.ITEM=function(a,c,d){return b.create("li",{innerHTML:""===c.trim()?a:a.replace(RegExp(b.regExpEscape(c.trim()),"gi"),"<mark>$&</mark>"),role:"option","aria-selected":"false",id:"awesomplete_list_"+this.count+"_item_"+d})},a.REPLACE=function(a){this.input.value=a.value},a.DATA=function(a){return a},Object.defineProperty(c.prototype=Object.create(String.prototype),"length",{get:function(){return this.label.length}}),c.prototype.toString=c.prototype.valueOf=function(){return""+this.label};var g=Array.prototype.slice;b.create=function(g,f){var a=document.createElement(g);for(var c in f){var e=f[c];if("inside"===c)b(e).appendChild(a);else if("around"===c){var d=b(e);d.parentNode.insertBefore(a,d),a.appendChild(d),null!=d.getAttribute("autofocus")&&d.focus()}else c in a?a[c]=e:a.setAttribute(c,e)}return a},b.bind=function(c,a){if(c)for(var b in a){var d=a[b];b.split(/\s+/).forEach(function(a){c.addEventListener(a,d)})}},b.unbind=function(c,a){if(c)for(var b in a){var d=a[b];b.split(/\s+/).forEach(function(a){c.removeEventListener(a,d)})}},b.fire=function(d,e,b){var a=document.createEvent("HTMLEvents");for(var c in a.initEvent(e,!0,!0),b)a[c]=b[c];return d.dispatchEvent(a)},b.regExpEscape=function(a){return a.replace(/[-\\^$*+?.()|[\]{}]/g,"\\$&")},b.siblingIndex=function(a){for(var b=0;a=a.previousElementSibling;b++);return b},"undefined"!=typeof self&&(self.Awesomplete=a),"undefined"!=typeof Document&&("loading"!==document.readyState?d():document.addEventListener("DOMContentLoaded",d)),a.$=b,a.$$=e,"object"==typeof module&&module.exports&&(module.exports=a)}();

class CosAutocomplete extends HTMLElement {
  connectedCallback() {
    this.settings = JSON.parse(this.getAttribute('data-settings')) || '{}';
    this.list = this.settings.list;

    if (!this.list) return;
    
    this.init();
  }

  init() {
    this._listeners = new Listeners();
    this.input = this.querySelector('input');
    this.classList.add('awesomplete');

    // this.isSpecialCity = window.cityAutocomplete.isSpecialCity;

    // this.allInputs = document.querySelectorAll('input');
    this.allNotifications = document.querySelectorAll(
      '[data-autocomplete-notification]'
    );

    if (!this.input) return;

    this._setupEventListeners();

    this.autocomplete = new Awesomplete(this.input, {
      list: this.list,
      sort: false,
      maxItems: this.list.length,
      minChars: 1,
      filter: (t, e) => {
        // console.log(t, e, RegExp(this._regExpEscape(e.trim()), "i"))
        return RegExp(this._regExpEscape(e.trim()), "i").test(t.value);
      },
      container: () => this,
      // insert label instead of value into the input.
      replace: (suggestion) => {
        // console.log('suggestion:', suggestion);
        this.input.value = suggestion.label;
        this.input.dispatchEvent(new Event("change"));
        // this._saveSelected(suggestion.value);
        // this._hideErrorMessage();
      },
      data: (item) => {
        return {
          label: item,
          value: this._replaceDiacritice(item),
        };
      },
    });

    const clearIcon = this.querySelector('[data-action="clear-autocomplete"]');
    if (clearIcon) {
      clearIcon.addEventListener('click', this._onClearIconClick.bind(this));
    }
  }

  _onClearIconClick() {
    this.input.value = '';
    this.input.dispatchEvent(new Event('change'));
  }

  _regExpEscape(t) {
    return this._replaceDiacritice(t.replace(/[-\\^$*+?.()|[\]{}]/g, "\\$&"));
  }

  destroy() {
    if (!this.autocomplete) return;

    this.input.required = false;

    this.autocomplete.destroy();
    if (this._listeners) {
      this._listeners.removeAll();
    }
  }

  _setupEventListeners() {
    this._listeners.add(this.input, "change", this._onInputChange.bind(this));
    // this._listeners.add(document, 'cart:rerendered', this._updateSpecial.bind(this));

    // this._listeners.add(this.input, 'keyup', () => {
    //   this.classList.toggle('is-filled', this.input.value !== '');
    // });
  }

  // _updateSpecial() {
  //   const isSpecialCity = this.container.querySelector('[data-is-special-city]')
  //   if (isSpecialCity) this.isSpecialCity = isSpecialCity.getAttribute('data-is-special-city');
  // }

  _replaceDiacritice(input) {
    let str = input.toLowerCase();

    const diacritice = "ă,â,î,ș,ş,ț,ţ".split(",");
    const nonDiacritice = "a,a,i,s,s,t,t".split(",");

    for (let i = 0; i < diacritice.length; i++) {
      str = str.replace(diacritice[i], nonDiacritice[i]);
    }

    return str;
  }

  _checkLivrare() {
    const term = this.input.value;

    window.cityAutocomplete.oraseLivrare.forEach((city) => {
      if (this._replaceDiacritice(term) === city) {
        return true;
      }
    });

    return false;
  }

  _checkSpecial() {
    const term = this.input.value;

    window.cityAutocomplete.oraseSpeciale.forEach((city) => {
      if (this._replaceDiacritice(term) === city) {
        return true;
      }
    });

    return false;
  }

  _isSpecialChanged() {
    if (this.isSpecialCity && !this._checkSpecial()) return true;

    return false;
  }

  _onInputChange() {
    this.timeout = setTimeout(() => {
      this._checkForm();
    }, 200);
  }

  _checkForm(form, noRefresh) {
    const term = this._replaceDiacritice(this.input.value);

    this.input.required = true;
    // console.log(
    //   'window.cityAutocomplete["hasRX"]:',
    //   window.cityAutocomplete["hasRX"]
    // );

    for (let index = 0; index < this.list.length; ) {
      const oras = this.list[index];
      const orasLivrare = this._replaceDiacritice(oras);

      if (term === orasLivrare) {
        // console.log('oras:', oras);
        this.input.setCustomValidity('');
        // return;
        return noRefresh ? null : this._updateList(term);
      } else {
        if (term === '') this._updateList();
        index++;
      }
    }

    const customValidityMessage = window.cityAutocomplete.hasRX
      ? "Serviciul de livrare PENTRU PRODUSELE MEDICAMENTOASE, temporar NU este disponibil pentru localitatea selectată"
      : "Temporar nu livrăm către localitatea selectată. Produsele pot fi rezervate în cea mai apropiată farmacie.";
    this.input.setCustomValidity(customValidityMessage);
    return this._fieldMessage(this.input);
    // this.input.checkValidity();
  }

  _onIconClick() {
    if (this.autocomplete.ul.childNodes.length === 0) {
      this.autocomplete.minChars = 0;
      this.autocomplete.evaluate();
      this.input.select();
    } else if (this.autocomplete.ul.hasAttribute("hidden")) {
      this.autocomplete.open();
      this.input.select();
    } else {
      this.autocomplete.close();
    }
  }

  _updateList(term) {
    const cosListaFarmacii = document.querySelector('cos-lista-farmacii');

    if (cosListaFarmacii) {
      cosListaFarmacii._onFilterCityChange(term);
      // cosListaFarmacii._updateList(term);  
    }
    
    // debugger;
    // document.dispatchEvent(new CustomEvent('theme:loading:start'));
    // document.documentElement.dispatchEvent(
    //   new CustomEvent('cart:refresh', {
    //     bubbles: true,
    //     detail: { scrollToTop },
    //   })
    // );
  }

  _fieldMessage(field, message, persist, ignoreField) {
    if (!field) return;
    const parent =
      field.type === 'checkbox'
        ? field.parentNode.parentNode
        : field.parentNode;

    if (!field.checkValidity() || ignoreField) {
      const text = message
        || field.type === 'checkbox'
        ? 'Te rugam sa bifezi aceasta casuta'
        : field.value === ''
        ? field.type === 'email'
          ? 'Pentru a va informa cand puteti ridica comanda dvs, rugam sa introduceti mail-ul'
          : 'Te rugam sa completezi acest camp'
        : field.validationMessage
        ? field.type === 'email'
          ? 'Te rugam sa incluzi o adresa de email valida'
          : field.validationMessage
        : 'Datele completate nu sunt valide';
      const oldMessage = parent.querySelector('[data-field-message]');

      if (persist)
        field.addEventListener(
          'change',
          () => {
            this._fieldMessage(field, false, true);
          },
          { once: true }
        );

      if (oldMessage) {
        oldMessage.innerText = text;

        return;
      }

      // const el = document.createElement('div');
      // el.className = 'product-form__error';
      // el.innerHTML = `<p class="alert alert--error" data-field-message>${text}</p></div>`;

      // parent.appendChild(el);
      // Animation.slideDown(el);

      // if (persist) return;
      // setTimeout(function () {
      //   Animation.slideUp(el, function () {
      //     el.remove();
      //   });
      // }, 5500);
    } else {
      // const oldEl = parent.querySelector('.product-form__error');

      // if (oldEl)
      //   Animation.slideUp(oldEl, function () {
      //     oldEl.remove();
      //   });
    }
  }
}
// check if the element is already defined
if (!customElements.get('cos-autocomplete')) customElements.define('cos-autocomplete', CosAutocomplete);